import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";

import { checkValidity } from "../../../../shared/utility";
import Input from "../../../../UI/Input/Input";
import classes from "./Reporter.css";
import ReactTooltip from "react-tooltip";
import Message from "../../../../components/Message/Message";
import moment from "moment";
import * as actions from "../../../../store/actions/index";

const ReportersComponent = (props) => {
  const [valid, setValid] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const dispatch = useDispatch();
  const [reporterForm, setReportersForm] = useState({
    reporter: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "reporter",
      },
      value: "",
      validation: {
        required: true,
        minLength: 2,
        maxLength: 255,
        pattern: "[a-zA-Z0-9]{1,30}",
      },
      disabled: true,
      valid: true,
      touched: false,
      label: "Agent",
      inputType: "QuickSearch",
    },
    // date: {
    //   elementType: "input",
    //   elementConfig: {
    //     type: "date",
    //     id: "date",
    //   },
    //   value: "",
    //   validation: {
    //     required: true,
    //     minLength: 5,
    //     maxLength: 10,
    //     pattern: "[0-9]",
    //     restrictFuture: true,
    //   },
    //   disabled: props.impactedMemberData ? true : false,
    //   valid: false,
    //   touched: false,
    //   label: "Reported Date (dd/mm/yyyy)",
    //   inputType: "QuickSearch",
    // },
    email: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "email",
      },
      value: "",
      validation: {
        required: false,
        minLength: 2,
        maxLength: 255,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      },
      disabled: true,
      valid: true,
      touched: false,
      label: "Email",
      inputType: "QuickSearch",
    },
    assignedTo: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "assignedTo",
      },
      value: "",
      validation: {
        required: true,
        minLength: 2,
        maxLength: 255,
        pattern: "[a-zA-Z0-9]{1,30}",
      },
      disabled: true,
      valid: true,
      touched: false,
      label: "Assigned To",
      inputType: "QuickSearch",
    },
    // time: {
    //   elementType: "input",
    //   elementConfig: {
    //     type: "time",
    //     id: "time",
    //   },
    //   value: "",
    //   validation: {
    //     required: false,
    //     minLength: 7,
    //     maxLength: 7,
    //   },
    //   disabled: props.impactedMemberData ? true : false,
    //   valid: valid,
    //   touched: false,
    //   label: "Reported Time (HH:mm:ss)",
    //   inputType: "QuickSearch",
    // },
    // timeZone: {
    //   elementType: "input",
    //   elementConfig: {
    //     type: "text",
    //     id: "timeZone",
    //   },
    //   value: "",
    //   validation: {
    //     required: false,
    //   },
    //   disabled: true,
    //   valid: true,
    //   label: "Time Zone",
    //   touched: false,
    //   inputType: "QuickSearch",
    // },
  });

  // console.log(reporterForm)

  const user = useSelector((state) => state.usr);

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...reporterForm };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };

    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
      setErrorMsg({ message: validation.message });
    } else {
      updatedFormElement.valid = false;
    }
    setValid(updatedFormElement.valid);
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setReportersForm(updatedForm);
    props.setReporterDetails(updatedForm);
  };

  const getDefaultTimeValues=()=>{
    let timeZoneOffset = new Date().getTimezoneOffset();
      const symbl = timeZoneOffset < 0 ? "+" : "-";
      if (timeZoneOffset < 0) timeZoneOffset *= -1;
      const time = String(timeZoneOffset / 60);
      const hours = "0" + time.split(".")[0];
      const minutes = time.split(".")[1]
        ? parseInt(time.split(".")[1]) * 6
        : "00";
      const timeZone =
        "GMT" +
        symbl +
        +hours +
        ":" +
        minutes +
        " " +
        Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = moment().format('YYYY-MM-DD');
        const todayTime = moment().format('hh:ss');
        return {
          timeZone, date, todayTime
        }
  }

  useEffect(() => {

      const {timeZone, date, todayTime} = getDefaultTimeValues()
      const userId = user?.user?.userLoginId;
      const agentEmailId = user?.user?.agentEmailId;
      const employeeId = user?.user?.employeeId;
      if (userId) {
        const form = { ...reporterForm };
        form.reporter.value = userId;
        form.email.value = agentEmailId;
        form.assignedTo.value = employeeId ?? userId;
        // form.timeZone.value = timeZone;
        // form.date.value = date;
        // form.time.value = todayTime;
        setReportersForm(form);
        props.setReporterDetails(form);
      }
  }, [user]);

  useEffect(() =>{
    dispatch(actions.getServiceNowAgent());
  },[])

  // useEffect(() => {
  //   if (reporterForm.date.valid && reporterForm.time.valid > 0) {
  //     props.isValid(true);
  //   } else {
  //     props.isValid(false);
  //   }
  // }, [reporterForm]);

  useEffect(()=>{
    const updatedForm = {}
    Object.keys(reporterForm)
    .map((key)=>{
      const reporterFormCopy = {...reporterForm[key]};
      reporterFormCopy.disabled = reporterFormCopy.disabled || props.formDisabled;
      updatedForm[key]= reporterFormCopy;
    })
    setReportersForm(updatedForm)
  },[props.formDisabled])

  const reporterDisplay = (
    <div style={{ display: "flex", flexFlow: "column", rowGap: "10px" }}>
      <div className={classes.formLayout}>
        {Object.keys(reporterForm)
          .filter((key) => key === "email" || key === "reporter" || key === "assignedTo")
          .map((key) => (
            <Input
              key={key}
              elementType={reporterForm[key].elementType}
              elementConfig={reporterForm[key].elementConfig}
              value={reporterForm[key].value}
              invalid={!reporterForm[key].valid}
              shouldValidate={reporterForm[key].validation}
              touched={reporterForm[key].touched}
              disabled={reporterForm[key].disabled}
              label={reporterForm[key].label}
              inputType={reporterForm[key].inputType}
              changed={(event) => inputChangedHandler(event, key)}
            />
          ))}
      </div>
      <div className={classes.timeLayout}>
        {Object.keys(reporterForm)
          .filter(
            (key) => key === "date" || key === "time" || key === "timeZone"
          )
          .map((key) => (
            <Input
              key={key}
              elementType={reporterForm[key].elementType}
              elementConfig={reporterForm[key].elementConfig}
              value={reporterForm[key].value}
              invalid={!reporterForm[key].valid}
              shouldValidate={reporterForm[key].validation}
              touched={reporterForm[key].touched}
              disabled={reporterForm[key].disabled}
              label={reporterForm[key].label}
              inputType={reporterForm[key].inputType}
              changed={(event) => inputChangedHandler(event, key)}
            />
          ))}
      </div>
    </div>
  );
  return (
    <>
      <div className={classes.FormTitle}>{"Agent"}
        &nbsp;<a data-tip data-for='agent'><span className="fa fa-question-circle"></span> </a>
        <ReactTooltip id='agent'>
          <span>Provide the details of agent</span>
        </ReactTooltip>
      </div>

      <div className={classes.box}>
        <Message msgType="Error" info={errorMsg} />
        {reporterDisplay}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
  };
};

export default connect(mapStateToProps, null)(ReportersComponent);
